/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getHotelVoucherDetailsApi } from '../../../api/hotelApi';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  formatDate,
  getNewDate,
  hideHeaderFooter,
  showHeaderFooter,
} from '../../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  checkValidEmailAddress,
} from '../../../shared/constants/Constants';
import './BookingDetails.scss';
import './Voucher.scss';
import StarRating from '../search-results/StarRating';
import AppButton from '../../../shared/components/app-button/AppButton';
import { emailFlightOptions } from '../../../api/flightApi';
import {
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import { getUserDetails } from '../../../api/profileApi';
import AppModal from '../../../shared/components/app-modal/AppModal';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import { APP_LOGO_URL } from '../../../saas/AppStorageStaticNames';

function HotelNewVoucher() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const passengerRef = useRef([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [agent, setAgent] = useState(undefined);
  const roomsRef = useRef([]);
  const imageUrl = `${
    appConfig?.appMainUrl
  }printlogos//qpdocs-docserver-1/${getUserAgentId()}.gif`;
  const [logoUrl, setLogoUrl] = useState(imageUrl);
  const [imageLoadError, setImageLoadError] = useState(false);

  useEffect(() => {
    setLogoUrl(imageUrl);
  }, [imageUrl]);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const getHotelVoucherDetails = async () => {
    setLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.StatusCode === '200') {
      const { User } = res.ApiStatus.Result;
      setAgent(User);
    } else {
      setAlert({
        variant: 'error',
        title: 'User Info',
        description: res?.ApiStatus?.Message,
      });
    }
    const response = await getHotelVoucherDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      data.hotelrooms = Array.isArray(data.hotelrooms)
        ? data.hotelrooms
        : [data.hotelrooms];
      data.hotelpax = Array.isArray(data.hotelpax)
        ? data.hotelpax
        : [data.hotelpax];
      let paxList = data.hotelpax;
      paxList = Array.isArray(paxList) ? paxList : [paxList];
      passengerRef.current = paxList;
      let roomsList = data.hotelrooms;
      roomsList = Array.isArray(roomsList) ? roomsList : [roomsList];
      roomsRef.current = roomsList;
      setBookingDetails(data);
      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Voucher Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel voucher details',
      });
      setHasTicket(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    getHotelVoucherDetails();
  }, []);

  const handleSendEmail = async () => {
    const fromName = `${agent.FirstName} ${agent.LastName}`;
    const fromEmail = agent.ContactEmail;
    const htmlContent = document.getElementById('ticketprint').innerHTML;
    if (toEmail === '' || checkValidEmailAddress(toEmail)) {
      setAlert({
        title: 'Email',
        description: 'please enter valid email',
        variant: 'error',
      });
      return false;
    }
    setLoading(true);
    const response = await emailFlightOptions(
      fromEmail,
      fromName,
      toEmail,
      htmlContent,
      'Your Hotel Booking Details',
    );
    if (response?.Root?.Status === 'OK') {
      setShowEmailModal(false);
      setToEmail('');
      setAlert({
        title: 'Email',
        description: 'Email Sent Successfully',
        variant: 'success',
      });
    } else {
      setAlert({
        title: 'Email',
        description: 'Failed to send Email Please try again',
        variant: 'error ',
      });
    }
    setLoading(false);
  };

  const getTotalRoomNights = (checkIn, checkout) => {
    try {
      const checkin_time = checkIn.split(' ')[0];
      const checkout_time = checkout.split(' ')[0];
      if (checkin_time && checkout_time) {
        const totNights =
          (getNewDate(checkout_time) - getNewDate(checkin_time)) /
          (1000 * 60 * 60 * 24);
        return totNights;
      }
      return '';
    } catch (error) {
      return '';
    }
  };
  const getPaxInfoForRoom = (roomId) => {
    // const eligiblePax = passengerRef.current.filter(
    //   (pax) => pax.roomid === roomId,
    // );
    const eligiblePax = passengerRef.current;
    if (eligiblePax.length > 0) {
      const names = [];
      eligiblePax.forEach((pax) => {
        const fullName = `${pax.salutation} ${pax.firstname} ${pax.lastname}`;
        names.push(fullName);
      });
      return (
        <span>
          {eligiblePax.length} Passenger(s)
          <br />
          {/* {names.join(<br />)} */}
          {names.map((name, index) => (
            <div key={index}>
              {name}
              <br />
            </div>
          ))}
        </span>
      );
    }
    return '';
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <section className="print-links d-flex flex-column hide-in-print">
        <div className="hide-in-print d-flex gap-2 flex-column">
          <AppButton
            btnText="Print"
            variant="green"
            onClick={() => window.print()}
          />
          <AppButton
            btnText="Email"
            variant="green"
            onClick={() => setShowEmailModal(true)}
          />
          <AppButton
            variant="green"
            btnText="Home"
            onClick={() => window.open(`${window.location.origin}/`, '_blank')}
          />
        </div>
      </section>
      {hasTicket !== undefined && hasTicket && (
        <div id="ticketprint">
          <div
            style={{
              maxWidth: '880px',
              margin: '20px auto',
              fontSize: '14px',
              padding: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 10px',
                backgroundColor: 'white',
                position: 'relative',
                border: '1px solid #000000',
                height: '80px',
                overflow: 'hidden',
              }}
            >
              {/* <img
                src={`${
                  appConfig?.appMainUrl
                }printlogos/${getUserAgentId()}.gif`}
                alt="logo"
                // eslint-disable-next-line no-return-assign
                onError={(e) => (e.target.src = getStringFromLS(APP_LOGO_URL))}
                style={{
                  width: '200px',
                  height: '80px',
                  objectFit: 'contain',
                  position: 'absolute',
                  overflow: 'auto',
                  left: '10px',
                }}
              /> */}
              {!imageLoadError && logoUrl ? (
                <img
                  src={logoUrl}
                  alt=""
                  style={{
                    width: '200px',
                    height: '80px',
                    objectFit: 'contain',
                    position: 'absolute',
                    overflow: 'auto',
                    left: '10px',
                  }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.target.src = null;
                    setImageLoadError(true);
                  }}
                />
              ) : (
                <img
                  src={getStringFromLS(APP_LOGO_URL)}
                  alt=""
                  style={{
                    width: '200px',
                    height: '80px',
                    objectFit: 'contain',
                    position: 'absolute',
                    overflow: 'auto',
                    left: '10px',
                  }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.target.src = null;
                  }}
                />
              )}

              <div
                style={{
                  fontSize: '24px',
                  fontWeight: '500',
                  backgroundColor: '#fff',
                  color: '#000000',
                  padding: '5px 10px',
                  borderRadius: '4px',
                }}
              >
                Hotel Voucher
              </div>
            </div>
            <table style={{ width: '100%', border: '1px solid #000000' }}>
              <thead style={{ color: '#000000', backgroundColor: '#e4e4e7' }}>
                <tr>
                  <th
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    Reference No
                  </th>
                  <th
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    Confirmation No
                  </th>
                  {/* <th
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    Hotel Confirmation No
                  </th> */}
                </tr>
              </thead>
              <tbody style={{ fontWeight: '300' }}>
                <tr>
                  <td
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    {bookingDetails.txid}
                  </td>
                  <td
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    {bookingDetails.supplier_reference}
                  </td>
                  {/* <td
                    style={{ border: '1px solid #000000', paddingLeft: '5px' }}
                  >
                    {bookingDetails.HotelConfirmationNo}
                  </td> */}
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                marginTop: '4px',
              }}
            >
              <thead>
                <tr>
                  <th style={{ paddingLeft: '5px' }}>Hotel Address Details</th>
                  <th
                    style={{
                      borderLeft: '1px solid #000000',
                      paddingLeft: '5px',
                    }}
                  >
                    Agency Address Details
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontWeight: '300', fontSize: '14px' }}>
                <tr>
                  <td style={{ paddingLeft: '5px', width: '50%' }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            {bookingDetails.hotel_name}
                            <StarRating rating={bookingDetails.hotel_rating} />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {bookingDetails.hotel_address},
                            {bookingDetails.hotel_cityreference}
                          </td>
                        </tr>
                        <tr>
                          <td>Fax : {bookingDetails.hotel_fax}</td>
                        </tr>
                        <tr>
                          <td>Mobile No: {bookingDetails.hotel_contact}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td
                    style={{
                      borderLeft: '1px solid #000000',
                      paddingLeft: '5px',
                      width: '50%',
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td>{agent.Company}</td>
                        </tr>
                        <tr>
                          <td>{agent.Address1}</td>
                        </tr>
                        <tr>
                          <td>{agent.Address2}</td>
                        </tr>
                        <tr>
                          <td>City : {agent.City}</td>
                        </tr>
                        <tr>
                          <td>Mobile No : {agent.ContactNumber}</td>
                        </tr>
                        <tr>
                          <td>Email : {agent.ContactEmail}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                marginTop: '5px',
              }}
            >
              <tbody>
                <tr>
                  <td style={{ paddingLeft: '5px' }}>
                    <span style={{ fontWeight: '500', color: '#000000' }}>
                      Lead Passenger Name:{' '}
                    </span>
                    <span>
                      {bookingDetails.leadpassenger_firstname}{' '}
                      {bookingDetails.leadpassenger_lastname}
                    </span>
                  </td>
                </tr>
                <tr style={{ width: '100%' }}>
                  <td style={{ paddingLeft: '5px' }}>
                    <span style={{ fontWeight: '500', color: '#000000' }}>
                      Check In Date:{' '}
                    </span>
                    <span>
                      {bookingDetails.checkin_time !== ''
                        ? formatDate(
                            getNewDate(
                              bookingDetails.checkin_time.split(' ')[0],
                            ),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )
                        : ''}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontWeight: '500', color: '#000000' }}>
                      Check Out Date:{' '}
                    </span>
                    <span>
                      {bookingDetails.checkout_time !== ''
                        ? formatDate(
                            getNewDate(
                              bookingDetails.checkout_time.split(' ')[0],
                            ),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )
                        : ''}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontWeight: '500', color: '#000000' }}>
                      No of Nights:{' '}
                    </span>
                    <span>
                      {getTotalRoomNights(
                        bookingDetails.checkin_time,
                        bookingDetails.checkout_time,
                      )}
                    </span>
                    <br />
                    <span style={{ fontWeight: '500', color: '#000000' }}>
                      No of Rooms:{' '}
                    </span>
                    <span>{bookingDetails.noof_rooms}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            {bookingDetails.hotelrooms.length > 0 && (
              <table
                style={{
                  width: '100%',
                  border: '1px solid #000000',
                  marginTop: '5px',
                }}
              >
                <thead style={{ color: '#000000', backgroundColor: '#e4e4e7' }}>
                  <tr>
                    <th
                      style={{
                        border: '1px solid #000000',
                        paddingLeft: '5px',
                      }}
                    >
                      S.No
                    </th>
                    <th
                      style={{
                        border: '1px solid #000000',
                        paddingLeft: '5px',
                      }}
                    >
                      Room Type
                    </th>
                    <th
                      style={{
                        border: '1px solid #000000',
                        paddingLeft: '5px',
                      }}
                    >
                      Guests
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bookingDetails.hotelrooms.map((room, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: '1px solid #000000',
                          paddingLeft: '5px',
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          border: '1px solid #000000',
                          paddingLeft: '5px',
                        }}
                      >
                        Room Description: {room.roomname} <br />
                        Incl : {room.mealplan} <br />
                        {/* Room Description: {room.room_description} */}
                      </td>
                      <td
                        style={{
                          border: '1px solid #000000',
                          paddingLeft: '5px',
                          textTransform: 'uppercase',
                        }}
                      >
                        {getPaxInfoForRoom(room.roomid)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Cancellation Policy :
                  </th>
                </tr>
                <tr>
                  <td style={{ fontWeight: '300', paddingLeft: '5px' }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: bookingDetails?.canxpolicy_modified?.replace(
                          /##/g,
                          '<br/>',
                        ),
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Remarks
                  </th>
                </tr>
                <tr>
                  <td style={{ fontWeight: '300', paddingLeft: '5px' }}>
                    Please note that while your booking had been confirmed and
                    is guaranteed, the rooming list with your name may not be
                    adjusted in the hotel's reservation system until closer to
                    arrival.
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Agent Remarks
                  </th>
                </tr>
                <tr>
                  <td style={{ fontWeight: '300', paddingLeft: '5px' }}>
                    {bookingDetails.agencyremark}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Booking Terms & Conditions
                  </th>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: '300',
                      paddingLeft: '5px',
                      fontSize: '14px',
                    }}
                  >
                    <ul>
                      <li>
                        You must present a photo ID at the time of check in.
                        Hotel may ask for credit card or cash deposit for the
                        extra services at the time of check in.
                      </li>
                      <li>
                        All extra charges should be collected directly from
                        clients prior to departure such as parking, phone calls,
                        room service, city tax, etc.
                      </li>
                      <li>
                        We don't accept any responsibility for additional
                        expenses due to the changes or delays in air, road,
                        rail, sea or indeed of any other causes, all such
                        expenses will have to be borne by passengers.
                      </li>
                      <li>
                        In case of wrong residency & nationality selected by
                        user at the time of booking; the supplement charges may
                        be applicable and need to be paid to the hotel by guest
                        on check in/ check out.
                      </li>
                      <li>
                        Any special request for bed type, early check in, late
                        check out, smoking rooms, etc are not guaranteed as
                        subject to availability at the time of check in.
                      </li>
                      <li>
                        Early check out will attract full cancellation charges
                        unless otherwise specified.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Hotel Policies
                  </th>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: '300',
                      paddingLeft: '5px',
                      fontSize: '14px',
                    }}
                  >
                    <ul>
                      <li>
                        As per the decree issued by UAE Government, 5% VAT shall
                        be levied for all the hotels booking whose check in are
                        from 1st Jan 2018 onward. The hotels may charge the same
                        directly from customers for past bookings whose check in
                        fall on or after 1st Jan 2018. Even if the accommodation
                        was booked and paid for before 1st January 2018. Please
                        inform your customers accordingly.
                      </li>
                      <li>
                        City tax and Resort fee are to be paid directly at hotel
                        if applicable.
                      </li>
                      <li>
                        Cancelled and rebooked reservations will be rejected,
                        regardless of the source reported to the hotel.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table> */}
            <table
              style={{
                width: '100%',
                border: '1px solid #000000',
                paddingLeft: '5px',
              }}
            >
              <tbody>
                <tr>
                  <th style={{ color: '#000000', paddingLeft: '5px' }}>
                    Contact Details:
                  </th>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: '300',
                      paddingLeft: '5px',
                      fontSize: '14px',
                    }}
                  >
                    Mobile No : {agent.ContactNumber}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontWeight: '300',
                      paddingLeft: '5px',
                      fontSize: '14px',
                    }}
                  >
                    Email : {agent.ContactEmail}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {showEmailModal && (
        <AppModal
          modalTitle="Email Voucher"
          showCloseButton
          onModalClose={() => setShowEmailModal(false)}
        >
          <div>
            <div className="d-flex gap-2">
              <AppTextInput
                onChange={(e) => setToEmail(e.target.value)}
                value={toEmail}
                name="toEmail"
                placeholderText=""
                label="Email to Send"
              />
              <AppButton
                btnText="Send Email"
                onClick={handleSendEmail}
                variant="outlined"
              />
            </div>
          </div>
        </AppModal>
      )}
    </div>
  );
}

export default HotelNewVoucher;
